import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from '@/utils/cx';
import useStyle from './style';
import Tick from '@/assets/tick.svg';

const Checkbox = ({
  onChange,
  checked,
  label,
  disabled,
  className,
  ...rest
}) => {
  const classes = useStyle();
  const [isChecked, setIsChecked] = useState(checked);

  function toggleCheckbox() {
    setIsChecked((wasChecked) => {
      onChange(!wasChecked);
      return !wasChecked;
    });
  }

  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label
      className={cx(
        classes.checkBox,
        className,
        { [classes.disabled]: disabled },
      )}
      {...rest}
    >
      <input className="input" type="checkbox" onChange={toggleCheckbox} checked={isChecked} disabled={disabled} />
      <span className="little-box">
        <Tick />
      </span>
      {label}
    </label>
  );
};

Checkbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element,
    PropTypes.string,
  ]),
};

Checkbox.defaultProps = {
  className: '',
  checked: false,
  label: '',
  disabled: false,
};

export default Checkbox;
